import React from 'react';
import EditIcon from '@atlaskit/icon/core/edit';
import EditIconLegacy from '@atlaskit/icon/glyph/edit';
import { Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

type Props = {
	statusName: string;
};

export const EditStatusButton = ({ statusName }: Props) => {
	const { formatMessage } = useIntl();
	// TODO: trigger edit status modal and fire analytics
	const onClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		event.stopPropagation(); // prevents transition from being selected
	};

	return (
		<Pressable
			tabIndex={0}
			xcss={iconButtonStyles}
			onClick={onClick}
			aria-label={formatMessage(messages.statusNameButtonLabel, {
				statusName,
			})}
			data-show-on-hover
		>
			<Tooltip content={formatMessage(messages.statusEditNameTooltip)} position="bottom">
				<EditIcon
					label=""
					LEGACY_fallbackIcon={EditIconLegacy}
					LEGACY_size="small"
					color={token('color.icon')}
				/>
			</Tooltip>
		</Pressable>
	);
};

const iconButtonStyles = xcss({
	borderRadius: 'border.radius',
	outlineOffset: 'space.0',
	padding: 'space.025',
	marginInline: 'space.100',
	opacity: 0,
	transition: 'opacity 0.3s ease',
	':focus': {
		boxShadow: 'elevation.shadow.overflow',
		opacity: 1,
	},
	':hover': {
		backgroundColor: 'color.background.neutral.subtle.hovered',
		opacity: 1,
	},
});
